/**
 * WEB-3447, заход 3 — ЕДИНЫЙ ленивый кусок плеера покупателя (решение
 * владельца 17.10 ~07:58: слить три двери ленивых кусков в одну, чтобы
 * уложить вес первого экрана). Три прежних набора — те же объекты:
 *  - `computedValues` — вычисляемые значения ({{bmi}} и др.);
 *  - `chrome` — рамка экрана Slimkit (`QUIZ_CHROME_KIT`);
 *  - `style` — градиенты бренда, переменные пака, ленивые темы (`STYLE_KIT`);
 *  - `numberBounds` — проверка числа по границам автора (WEB-2351, возврат 1:
 *    вес первого экрана).
 * Первый экран статически этот файл НЕ тянет (сторож сборки
 * FIRST_SCREEN_DEFERRED_MODULES); дверь — `playerKitDoor.ts`, ждёт страница
 * одной дверью (`usePlayerKitDoor.ts`). Цена слияния: воронке, которой нужен
 * один набор, едут все три (один запрос вместо до трёх).
 */
import * as computedValues from './computedValues';
import { QUIZ_CHROME_KIT } from '@/components/quiz-runtime/quizChromeKit';
import { STYLE_KIT } from '@/themes/styleKit';
import * as numberBounds from '@/components/quiz-runtime/numberBounds';
import type { PlayerKit } from './playerKitDoor';

export const PLAYER_KIT: PlayerKit = {
  computedValues,
  chrome: QUIZ_CHROME_KIT,
  style: STYLE_KIT,
  numberBounds,
};
